<template>
    <simple-tour-booking-page-layout
        v-if="loaded && offer"
        :search-request="searchRequest"
        :offer="offer"
        :product="product"
        :product-store="productStore"
        :search-request-country-id="searchRequestCountryId"
        tourist-passport-form
    >
        <template v-slot:breadcrumbs>
            <expired-offers-snackbar :is-offers-expired="isOffersExpired" @refresh="refreshExpiredOffers" />
            <simple-tour-breadcrumbs :search-request="searchRequest" :product="product" />
        </template>
        <template v-slot:sidebar="{bookingKey, selectedAddOns, extraServices}">
            <simple-tour-order-summary
                :offer="offer"
                :product="product"
                :prebooked="!!bookingKey"
                :info="basketItem.info"
                :selected-add-ons="selectedAddOns"
                :extra-services="extraServices"
                :search-request="searchRequest"
                :additional-options="productStore.bookingAdditionalOptions"
            >
                <template v-slot:summary>
                    <v-card flat rounded="0" class="my-2 pa-0">
                        <v-card-text class="pa-0">
                            <search-summary-content
                                :search-request="searchRequest"
                                :date-prop="offer.date"
                                tourists-label="guest"
                                show-date
                                show-tourists
                            />
                        </v-card-text>
                    </v-card>
                </template>
            </simple-tour-order-summary>
        </template>
        <template v-slot:orderCommentsForm="{bookingKey, basketKey, formRefs}">
            <booking-comments-form
                :ref="el => formRefs.push(el)"
                :disabled="!!bookingKey || !!basketKey"
                :product-store="productStore"
            />
        </template>
        <conditions-modal>
            <template v-slot:info>
                <activity-conditions-modal-info />
            </template>
        </conditions-modal>
        <simple-tour-offer-info-modal />
    </simple-tour-booking-page-layout>
</template>

<script lang="ts">
    import {Component, mixins, Provide} from 'vue-facing-decorator'
    import {ProductBookingFieldsMixin} from '@/components/booking/mixins/ProductBookingFieldsMixin.vue'
    import {SimpleTourPageMixin} from '@/components/simpleTours/mixins/SimpleTourPageMixin.vue'
    import {SimpleTourMixin} from '@/mixins/SimpleTourMixin.vue'
    import SimpleTourBreadcrumbs from '~/components/simpleTours/SimpleTourBreadcrumbs.vue'
    import SimpleTourBookingPageLayout from '~/components/simpleTours/booking/SimpleTourBookingPageLayout.vue'
    import SimpleTourOrderSummary from '~/components/simpleTours/booking/SimpleTourOrderSummary.vue'
    import SearchSummaryContent from '@/components/parts/SearchSummaryContent.vue'
    import ConditionsModal from '@/components/modals/ConditionsModal.vue'
    import ActivityConditionsModalInfo from '@/components/activities/snippets/ActivityConditionsModalInfo.vue'
    import SimpleTourOfferInfoModal from '@/components/simpleTours/info/SimpleTourOfferInfoModal.vue'
    import ExpiredOffersSnackbar from '@/components/search/ExpiredOffersSnackbar.vue'
    import {UTCToDate} from '@/utils/helpers'
    import BookingCommentsForm from '~src/components/booking/forms/bookingCommentsForm.src'
    import {bookingFields} from '@/utils/simpleTours/simple-tour-blank-states'

    @Component({
        components: {
            SimpleTourBookingPageLayout,
            SimpleTourBreadcrumbs,
            SimpleTourOrderSummary,
            SimpleTourOfferInfoModal,
            ActivityConditionsModalInfo,
            ConditionsModal,
            ExpiredOffersSnackbar,
            BookingCommentsForm,
            SearchSummaryContent,
        },
    })
    export class SimpleTourBookingPage extends mixins(SimpleTourMixin, SimpleTourPageMixin, ProductBookingFieldsMixin) {
        loaded = false

        async mounted() {
            await this.$store.restored
            await this.loadRuntimeData()
            await runtimeStore.loadTouristBookingFields({offerKey: this.$route.query.offerKey})
            await runtimeStore.loadProductBookingFields({offerKey: this.$route.query.offerKey})
            this.productStore.clearBookingAdditionalOptions()
            await this.productStore.getExtraServiceAdditionalOptions(this.$route.query.offerKey)

            runtimeStore.SET_CUSTOM_TOURIST_BOOKING_FIELDS(bookingFields())
            this.loaded = true
        }

        isOffersExpired() {
            return (
                this.$dateFns.isAfter(new Date(), UTCToDate(this.$dateFns.parseISO(this.basketItem.expirationTime))) &&
                !runtimeStore.bookingActive &&
                !this.productStore.prepareBookResponse.bookingKey
            )
        }

        refreshExpiredOffers() {
            this.$router.push(this.productRuntimeStore.searchPageLink(this.searchRequest))
        }

        get prepareBookRequest() {
            return this.productStore.prepareBookRequest
        }

        get searchRequestCountryId() {
            return this.productRuntimeStore.city.countryId
        }

        get basketItem() {
            return this.productStore.basketItem(this.$route.query.offerKey)
        }

        @Provide get searchRequest() {
            return this.basketItem.searchRequest
        }

        get product() {
            return this.basketItem.product
        }

        get offer() {
            return this.product.offers.find(offer => offer.offerKey === this.$route.query.offerKey)
        }
    }

    export default SimpleTourBookingPage
</script>
